module.exports = __webpack_public_path__ + "img/winerackdog34.55466ab0.jpg";